<!-- @catalog Full-width "toevoegen" row closing a CGridTable or a CGridTableGroup: a plus icon with a label, emits `click`. `sub` indents it under a group's chevron column. -->
<template>
  <c-grid-table-row :sub="sub">
    <div class="c-grid-table-add-row__cell" role="cell">
      <c-button
        color="transparent"
        text-color="navy"
        :label="label"
        :icon="toClassicIcon(addIcon, 'solid')"
        @click="emit('click')"
      />
    </div>
  </c-grid-table-row>
</template>

<script setup lang="ts">
import { addIcon, toClassicIcon } from "common/defaultIcons";

withDefaults(defineProps<{ label: string; sub?: boolean }>(), { sub: false });

const emit = defineEmits<{ (event: "click"): void }>();
</script>

<style lang="scss" scoped>
.c-grid-table-add-row__cell {
  grid-column: 1 / -1;
}

// The `sub` row already holds the indent cell in the first column.
.c-grid-table-row--sub .c-grid-table-add-row__cell {
  grid-column: 2 / -1;
}
</style>
